/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of DIGITALX LABS(PVT)LTD.  The intellectual and technical concepts contained
 *  herein are proprietary to DIGITALX LABS(PVT)LTD.
 *  Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  is strictly forbidden unless prior written permission is obtained from DIGITALX LABS(PVT)LTD.
 */
import React, { createContext, useState, useMemo, useEffect } from 'react'
import PropTypes from 'prop-types'

export const AuthContext = createContext(null)

const AuthContextProvider = (props) => {
  const [authState, setAuthState] = useState(JSON.parse(sessionStorage.getItem('authState')))
  const [mobileNumberState, setMobileNumberState] = useState(null)

  const valueProvider = useMemo(() => ({
    authState,
    setAuthState,
    mobileNumberState,
    setMobileNumberState
  }), [authState, mobileNumberState])

  useEffect(() => {
    sessionStorage.setItem('authState', JSON.stringify(authState))
  }, [authState])

  return (
        <AuthContext.Provider value={valueProvider}>
            {props.children}
        </AuthContext.Provider>
  )
}

AuthContextProvider.propTypes = {
  children: PropTypes.element
}

export default AuthContextProvider
